import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { EventDto } from '@/types/dtos/events/response/event.dto.ts';
import { GET_EVENT_QUERY_KEY } from '../../queries/events/use-get-event.ts';
import { GET_EVENT_FLOWS_QUERY_KEY } from '../../queries/flows/use-get-event-flows.ts';
import { invalidatePublicationStateQueries } from '@/state/queries/events/use-publication-state';

export type AddEventSlotDto = {
  eventId: string;
  flowId: string;
  eventDayId: string;
  startTime: string;
  endTime?: string;
};

export const useAddEventSlotMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AddEventSlotDto) => {
      const token = await getToken();
      return addEventSlot(data, token ?? '');
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_QUERY_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [GET_EVENT_FLOWS_QUERY_KEY],
        }),
        invalidatePublicationStateQueries(queryClient),
      ]);
    },
  });
};

const addEventSlot = async (data: AddEventSlotDto, token: string): Promise<EventDto> => {
  const { eventId, flowId, eventDayId, startTime, endTime } = data;
  const url = `${import.meta.env.VITE_API_URL}/events/${eventId}/slots`;
  return sendJSONRequest({
    url,
    method: METHOD.POST,
    body: {
      flowId,
      eventDayId,
      startTime,
      endTime,
    },
    token,
  });
};
